// composition/useAutoLogout.ts
import { ref, watch, onMounted } from 'vue';

export default function useAutoLogout(timeout: number, logoutCallback: () => void) {
  const lastActivity = ref<number>(Date.now());

  const resetTimer = () => {
    lastActivity.value = Date.now();
  };

  // Watch for user activity
  watch(
    () => lastActivity.value,
    () => {
      resetTimer();
    }
  );

  // Check for inactivity and trigger logout if necessary
  const checkInactivity = () => {
    const currentTime = Date.now();
    const inactivityPeriod = currentTime - lastActivity.value;
    if (inactivityPeriod >= timeout) {
      // console.log("logout");
      logoutCallback();
    } else {
      setTimeout(checkInactivity, 1000); // Check every second
    }
  };

  onMounted(() => {
    // Start checking for inactivity when the component is mounted
    setTimeout(checkInactivity, 1000);
  });

  return { resetTimer };
}
